module.exports = __webpack_public_path__ + "static/media/6.60d83142.jpg";